class DesktopUpsells extends HTMLElement {
  constructor() {
    super();

  }

  open() {
    this.classList.remove('tw-hidden');
  }
  close() {
    this.classList.add('tw-hidden');
  }

  renderContents(parsedState, updateUpsells = true) {
    this.productId = parsedState.id;

    if (this.querySelector('[data-recommended-items-container-desktop]')?.innerHTML === '') {
      this.querySelector('[data-upsell]')?.classList?.add('hide');
    }

    this.open();

    if (updateUpsells) {

      function toggleShowUpsells() {
        const upsellsContainer = document.querySelector('[data-recommended-items-container-desktop]');
        const upsellsHeading = document.querySelector('[data-upsell-heading]');
        const upsells = document.querySelector('[data-upsell]');
        if (upsellsContainer?.innerHTML === '') {
          !upsellsContainer?.classList?.contains('hide') ? upsellsContainer?.classList?.add('hide') : null;
          !upsells?.classList?.contains('hide') ? upsells?.classList?.add('hide') : null;
          upsellsHeading.classList.add('!tw-hidden');
        } else {
          upsellsContainer?.classList?.contains('hide') ? upsellsContainer?.classList?.remove('hide') : null;
          upsells?.classList?.contains('hide') ? upsells?.classList?.remove('hide') : null;
          upsellsHeading.classList.remove('!tw-hidden');
        }
      }
      const line_items = document.querySelectorAll('.cart-notification-row');
      const line_items_valid = Array.from(line_items)?.filter(
        (item) => item.querySelector('.item-property-product-type')?.value !== 'drawer'
      );
      const line_items_upsell_skus = line_items_valid[0]?.querySelector('.item-product-meta')?.value;
      const incart_skus_array = Array.from(line_items)?.map((item) => item.querySelector('.item-product-sku')?.value?.trim());

      const upsell_skus_array = line_items_upsell_skus?.split(',');
      const removed_upsells_skus = document.querySelector('.removed_upsells_skus')?.value;
      const removed_upsells_skus_array = removed_upsells_skus?.split(',');
      const upsell_valid_skus = upsell_skus_array
        ?.filter((item) => !incart_skus_array.includes(item.trim()))
        ?.map((item) => item.trim());

      const upsell_product_type_attr = line_items_valid[0]
        .querySelector('.item-product-type')
        ?.value.toUpperCase()
        .replaceAll(' ', '-');
      const upsell_product_types = upsell_product_type_attr
        .split(',')
        ?.filter((item) => !incart_skus_array.includes(item.trim()))
        ?.map((item) => item.trim());

      let skuQueryStr = '';
      let typeQueryStr = '';
      let skuArr = [];
      let typeArr = [];

      skuArr = upsell_valid_skus.reduce((prev, sku) => {
        if (sku.trim().length > 0) {
          prev.push(`tag:sku-${sku.trim()}`);
        }
        return prev;
      }, []);

      typeArr = upsell_product_types.reduce((prev, type) => {
        if (type.trim().length > 0) {
          prev.push(`tag:TYPE-${type.split('__')[0]?.trim()}`);
        }
        return prev;
      }, []);

      skuQueryStr = skuArr.join(' OR ');
      typeQueryStr = typeArr.join(' OR ');

      let itemsContainer = document.querySelector('[data-recommended-items-container-desktop]');
      itemsContainer.innerHTML = '';

      if (skuQueryStr.length > 0) {
        let itemTemplate = document.querySelector('#recommended-item-template-desktop');

        fetch(GRAPHQL_URL_GENERAL, GRAPHQL_BODY_GENERAL(fetchVariantDefaultProduct, skuQueryStr))
          .then((res) => res.json())
          .then(async (response) => {
            let fallbackProductOverride = false;
            let edges = response.data.products.edges;
            let availableSkuEdges = edges.reduce((arr, edge) => {
              if (
                edge.node.variants.edges.find((edge) => {
                  let variant = edge.node;
                  return upsell_valid_skus.includes(variant.sku) && variant.availableForSale;
                })
              ) {
                arr.push(edge);
              }
              return arr;
            }, []);
            if (availableSkuEdges.length == 0 && typeQueryStr.length > 0) {
              let fallbackProductRes = await fetch(
                GRAPHQL_URL_GENERAL,
                GRAPHQL_BODY_GENERAL(fetchVariantDefaultProduct, typeQueryStr)
              );
              response = await fallbackProductRes.json();
              edges = response.data.products.edges;
              fallbackProductOverride = true;
              var fallbackType = upsell_product_types[0].split('__')[0]?.trim();
              var fallbackSku = upsell_product_types[0].split('__')[1]?.trim();
            }

            let count = 0;
            for (var i = 0; i < edges.length; i++) {
              let variants = edges[i].node.variants.edges;
              let title = edges[i].node.title;
              for (var j = 0; j < variants.length; j++) {
                let variantData = variants[j].node;
                let tags = edges[i].node.tags;
                if (
                  (upsell_valid_skus.includes(variantData.sku) ||
                    (fallbackProductOverride &&
                      tags.find((tag) => {
                        return tag.includes(fallbackType);
                      }) &&
                      (fallbackSku ? fallbackSku.includes(variantData.sku) : true))) &&
                  !removed_upsells_skus_array.includes(variantData.sku) &&
                  count <= 2
                ) {
                  if (variantData.availableForSale) {
                    let item = itemTemplate.cloneNode(true);
                    item.removeAttribute('id');
                    item?.classList.remove('hide');
                    document.querySelector('[data-upsell]').classList?.remove('hide');
                    item.querySelector('.cart-notification-product__name').innerHTML = title;
                    // item.querySelector('.cart-notification-product__variants').innerHTML = variantData.title;
                    item.querySelector('.cart-drawer-price').innerHTML = `£${parseFloat(variantData.price.amount)
                      .toFixed(2)
                      .replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}`;
                    item.querySelector('.quantity__input').value = 1;
                    item.querySelector('.cart-notification-product__image img').src = variantData.image.url;
                    item.querySelector('.cart-notification-product__image img').alt = variantData.title;
                    item.querySelector('.recommended-max-quantity').value = variantData.quantityAvailable;
                    item.querySelector('.recommended-available').value = variantData.availableForSale;
                    item.querySelector('.recommended-variant-id').value = variantData.id.split('/').pop();
                    item.querySelector('.recommended-price').value = parseFloat(variantData.price.amount).toFixed(2);
                    item.querySelector('.recommended-sku').value = variantData.sku;
                    item.querySelector('.recommended-product_type').value = edges[i].node.productType;
                    item.querySelector('.recommended-product_vendor').value = edges[i].node.vendor;
                    item.querySelector('.recommended-product_id').value = edges[i].node.id.split('/').pop();
                    item.querySelector('.recommended-product_handle').value = edges[i].node.handle;

                    itemsContainer.appendChild(item);
                    count++;
                  }
                }
              }
            }
            toggleShowUpsells();
          });
      } else {
        toggleShowUpsells();
      }
    } // doNotUpdateUpsells conditional
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

}

customElements.define('desktop-upsells', DesktopUpsells);

